<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Reporte de stock mínimo</h1>
          <p class="view-header__subtitle">{{ subtitleText }}</p>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="row">
      <div class="col-12">
        <div class="stats-card">
          <div
            class="stats-card__value"
            :class="minStockNumber > 0 ? 'stats-card__value--danger' : 'stats-card__value--success'"
          >
            {{ minStockNumber }}
          </div>
          <div class="stats-card__label">{{ statsLabel }}</div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <q-select v-model="filters.brand_id" :options="brandFilterOptions" placeholder="- Todas las Marcas -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.category_id" :options="categoryOptions" placeholder="- Todas las Categorías -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.provider_id" :options="providerFilterOptions" placeholder="- Todos los Proveedores -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.warehouse_id" :options="warehouseOptions" placeholder="- Todos los Depósitos -" searchable />
          </div>
          <div class="filters-panel__field">
            <q-select v-model.number="filters.active" :options="activeOptions" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filters.mode" :options="modeOptions" />
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from "vuex";

export default {
  components: {
    VdtnetTable,
    QSelect,
  },
  data: function () {
    return {
      minStockNumber: 0,
      filters: {
        brand_id: null,
        category_id: null,
        provider_id: null,
        warehouse_id: null,
        active: 1,
        mode: 'minimum',
      },
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        autoWidth: false,
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/stockmin",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
          data: (d) => {
            d.filters = this.filters;
            return d;
          },
        },
      },
      fields: {
        name: { label: "Nombre" },
        stock_minimum: { label: "Mínimo" },
        stock: { label: "Cantidad" },
        provname: { label: "Proveedor" },
        phone: { label: "Teléfono" },
        email: { label: "E-mail" },
      },
    };
  },
  watch: {
    'filters.active'() { this.refreshAll(); },
    'filters.brand_id'() { this.refreshAll(); },
    'filters.category_id'() { this.refreshAll(); },
    'filters.provider_id'() { this.refreshAll(); },
    'filters.warehouse_id'() { this.refreshAll(); },
    'filters.mode'() { this.refreshAll(); },
  },
  computed: {
    statsLabel() {
      return this.filters.mode === 'critical'
        ? 'Productos agotados o con stock negativo'
        : 'Productos debajo del mínimo de stock';
    },
    subtitleText() {
      return this.filters.mode === 'critical'
        ? 'Productos con stock en cero o negativo (sobrevendidos), tengan o no un mínimo configurado.'
        : 'Productos cuyo stock cayó por debajo del mínimo configurado.';
    },
    modeOptions() {
      return [
        { value: 'minimum', label: 'Bajo stock mínimo' },
        { value: 'critical', label: 'Agotados / stock negativo' },
      ];
    },
    ...mapState("categories", { categories: (state) => state.categories }),
    ...mapState("warehouse", { warehouse: (state) => state.warehouse }),
    ...mapState("brands", { brands: (state) => state.brands }),
    ...mapState("providers", { providers: (state) => state.providers }),
    brandFilterOptions() {
      return [{ value: 'Sin marca', label: 'Sin Marca' }, ...this.brands.map(brand => ({ value: brand.id, label: brand.name }))];
    },
    categoryOptions() {
      return this.categories.map(category => ({ value: category.id, label: category.name }));
    },
    providerFilterOptions() {
      return [{ value: 'Sin proveedor', label: 'Sin Proveedor' }, ...this.providers.map(provider => ({ value: provider.id, label: provider.name }))];
    },
    warehouseOptions() {
      return (Array.isArray(this.warehouse) ? this.warehouse : []).map(w => ({ value: w.id, label: w.name }));
    },
    activeOptions() {
      return [
        { value: 0, label: 'Todos los productos' },
        { value: 1, label: 'Sólo productos activos' },
        { value: 2, label: 'Sólo productos inactivos' },
      ];
    },
  },
  created() {
    this.$store.dispatch("categories/getCategories");
    this.$store.dispatch("warehouse/getWarehouses");
    this.$store.dispatch("brands/getBrands");
    this.$store.dispatch("providers/getProviders");
  },
  mounted() {
    this.getMinStockReport();
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    refreshAll() {
      this.getMinStockReport();
      this.refreshTable();
    },
    getMinStockReport() {
      this.$http.get("/api/reports/stockmin_number", { params: this.filters })
        .then((response) => {
          this.minStockNumber = response.data.data;
        })
        .catch((error) => {
          console.error('getMinStockReport:', error);
        });
    },
  },
};
</script>
